import { DASHBOARD_CARDS_VALUE } from './types';

const initialState = {
    card: {
      balance: 0.0,
      incomes: 0.0,
      outcomes: 0.0,
      futureReleases: 0.0,
      operationsCount: 0
    }
};

export function ZwalletDashboardReducer(state=initialState, action) {
    let payload;
    switch(action.type) {
        case DASHBOARD_CARDS_VALUE:
            payload = action.payload;

            return {
                ...state,
                card: {...payload}
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/reducers.js